import { FC } from "react";
import "./SelectFileButton.css";
import { uploadMedia, uploadMultipleMedia } from "../../../api/mediaApi";
import { useProgressStore } from "../../../hooks/useProgress";
import { Guid } from "../../../api/baseApi";
import { uploadMediaForCampaign } from "../../../api/campaingsApi";

interface SelectFileButtonProps {
    title?: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

interface SelectMultipleFileButtonProps {
    title? : string, 
    campaignId?: Guid,
    onMediaUploaded:()=>void
}

interface SelectAvatarButtonProps extends SelectFileButtonProps{
    id: string
}
 
const SelectFileButton: FC<SelectFileButtonProps> = (props: SelectFileButtonProps) => {
    let { onChange, title = 'Add Media' } = props 
    return ( 
        <div className="form-group">
            <label htmlFor="upload" className="btn primary_btn">{title}</label>
            <input id="upload" type="file" name="upload" accept=".mp4,.jpg,.png" onChange={onChange}/>
        </div>
     );
}

export const SelectAvatarButton: FC<SelectAvatarButtonProps> = (props: SelectAvatarButtonProps) => {
    let { onChange, title = 'Upload media', id } = props 
    return ( 
        <div className="form-group">
            <label htmlFor={id} className="btn primary_btn">{title}</label>
            <input id={id} type="file" name={id} accept=".jpg,.png" onChange={onChange}/>
        </div>
    );
}

type GeneratePreviewResult = {
    url: string,
    duration: number
}

export const SelectMultipleFileButton: FC<SelectMultipleFileButtonProps>= ({ title ="Upload Multiple Files", campaignId, onMediaUploaded }) => {
    const progressStore = useProgressStore();

    const checkIsDisabled = () => progressStore.progress !== 0

    const generatePreview = (videoFile: File): Promise<GeneratePreviewResult> => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.setAttribute('playsinline', '');
            video.setAttribute('controls', '');
            video.setAttribute('type', 'video/mp4');

    

    
            video.preload = 'metadata';
          

            video.src = URL.createObjectURL(videoFile);
            console.log(video);
            video.load();
            video.onloadedmetadata = () => {
                console.log(video.duration);
                setTimeout(() => {
                    video.currentTime = video.duration / 2;
                    console.log("time", video );
                  }, 200);
            };
    
            video.onseeked = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                console.log("seekend", video );
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                if (!ctx) {
                    reject(new Error('Could not get canvas context'));
                    return;
                }
                ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
                canvas.toBlob((blob) => {
                    if (blob) {
                        const url = canvas.toDataURL('image/png');
                        resolve({url: url, duration: video.duration});
                    } else {
                        reject(new Error('Could not create blob from canvas'));
                    }
                }, 'image/jpeg');
            };
    
            video.onerror = (event) => {
                reject(new Error('Error loading video file'));
            };
    
          
        });
    };

    const onFileChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        if(event.target.files && event.target.files.length != 0){
            const formData = new FormData();
            const selectedFiles = Array.from(event.target.files as FileList);

            for(var index = 0 ; index < selectedFiles.length; index++){
                console.log("promise")
                var file = selectedFiles[index];
                formData.append(`Media`, file);
                    if (file.type.startsWith('video/')) {
                        try {
                            const generatePreviewResult = await generatePreview(file);

                            console.log("Preview ", generatePreviewResult.url)
                            const previewFile = new File([generatePreviewResult.url], `${file.name}`, { type: 'image/png' });
                            formData.append('Preview', previewFile, `${file.name}`);
                            formData.append('Duration[]', `${file.name}#${generatePreviewResult.duration}`);
                            console.log('Generated preview for:', file.name);
                        } catch (error) {
                            console.error('Error generating preview:', error);
                        }
                    }
            }


            if(campaignId){
                await uploadMediaForCampaign(formData, campaignId, progressStore.updateProgress);
            } else {
                await uploadMultipleMedia(formData, progressStore.updateProgress);
            }
            progressStore.resetProgress();
            onMediaUploaded();
        }
    }
    return ( 
        <div className="form-group">
            <label htmlFor="upload-multiple" className={`btn primary_btn ${checkIsDisabled() ? "disabled" : ""}`}>{title}</label>
            <input multiple id="upload-multiple" type="file" name="upload-multiple" accept=".mp4,.jpg,.png" onChange={onFileChange} disabled={checkIsDisabled()}/>
        </div>
     );
}
 
export default SelectFileButton;